import { firebaseConfig } from '../firebase/firebase';

export const environment = {
  name: 'sandbox',
  production: false,
  API_HOST: 'weguide-sandbox.xyz',
  firebaseConfig,
  updateInterval: undefined, // default 5 minutes
};
